export const primeVueLocaleEn = {
  startsWith: 'Starts with',
  contains: 'Contains',
  notContains: 'Not contains',
  endsWith: 'Ends with',
  equals: 'Equals',
  notEquals: 'Not equals',
  noFilter: 'No Filter',
  lt: 'Less than',
  lte: 'Less than or equal to',
  gt: 'Greater than',
  gte: 'Greater than or equal to',
  dateIs: 'Date is',
  dateIsNot: 'Date is not',
  dateBefore: 'Date is before',
  dateAfter: 'Date is after',
  clear: 'Clear',
  apply: 'Apply',
  matchAll: 'Match All',
  matchAny: 'Match Any',
  addRule: 'Add Rule',
  removeRule: 'Remove Rule',
  accept: 'Yes',
  reject: 'No',
  choose: 'Choose',
  upload: 'Upload',
  cancel: 'Cancel',
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  chooseYear: 'Choose Year',
  chooseMonth: 'Choose Month',
  chooseDate: 'Choose Date',
  prevDecade: 'Previous Decade',
  nextDecade: 'Next Decade',
  prevYear: 'Previous Year',
  nextYear: 'Next Year',
  prevMonth: 'Previous Month',
  nextMonth: 'Next Month',
  prevHour: 'Previous Hour',
  nextHour: 'Next Hour',
  prevMinute: 'Previous Minute',
  nextMinute: 'Next Minute',
  prevSecond: 'Previous Second',
  nextSecond: 'Next Second',
  am: 'am',
  pm: 'pm',
  today: 'Today',
  weekHeader: 'Wk',
  firstDayOfWeek: 0,
  dateFormat: 'mm/dd/yy',
  weak: 'Weak',
  medium: 'Medium',
  strong: 'Strong',
  passwordPrompt: 'Enter a password',
  emptyFilterMessage: 'No results found',
  emptyMessage: 'No available options',
  aria: {
    trueLabel: 'True',
    falseLabel: 'False',
    nullLabel: 'Not Selected',
    star: '1 star',
    stars: '{star} stars',
    selectAll: 'All items selected',
    unselectAll: 'All items unselected',
    close: 'Close',
    previous: 'Previous',
    next: 'Next',
    navigation: 'Navigation',
    scrollTop: 'Scroll Top',
    moveTop: 'Move Top',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    moveBottom: 'Move Bottom',
    moveToTarget: 'Move to Target',
    moveToSource: 'Move to Source',
    moveAllToTarget: 'Move All to Target',
    moveAllToSource: 'Move All to Source',
    pageLabel: 'Page {page}',
    firstPageLabel: 'First Page',
    lastPageLabel: 'Last Page',
    nextPageLabel: 'Next Page',
    prevPageLabel: 'Previous Page',
    rowsPerPageLabel: 'Rows per page',
    jumpToPageDropdownLabel: 'Jump to Page Dropdown',
    jumpToPageInputLabel: 'Jump to Page Input',
    selectRow: 'Row Selected',
    unselectRow: 'Row Unselected',
    expandRow: 'Row Expanded',
    collapseRow: 'Row Collapsed',
    showFilterMenu: 'Show Filter Menu',
    hideFilterMenu: 'Hide Filter Menu',
    filterOperator: 'Filter Operator',
    filterConstraint: 'Filter Constraint',
    editRow: 'Row Edit',
    saveEdit: 'Save Edit',
    cancelEdit: 'Cancel Edit',
    listView: 'List View',
    gridView: 'Grid View',
    slide: 'Slide',
    slideNumber: '{slideNumber}',
    zoomImage: 'Zoom Image',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    rotateRight: 'Rotate Right',
    rotateLeft: 'Rotate Left',
  },
};

export const primeVueLocaleFr = {
  startsWith: 'Commence par',
  contains: 'Contient',
  notContains: 'Ne contient pas',
  endsWith: 'Se termine par',
  equals: 'Egal',
  notEquals: 'Diff\u00e9rent',
  noFilter: 'Aucun filtre',
  lt: 'Inf\u00e9rieur \u00e0',
  lte: 'Inf\u00e9rieur ou \u00e9gal \u00e0',
  gt: 'Sup\u00e9rieur \u00e0',
  gte: 'Sup\u00e9rieur ou \u00e9gal \u00e0',
  dateIs: 'La date est',
  dateIsNot: 'La date n\'est pas',
  dateBefore: 'La date est avant',
  dateAfter: 'La date est apr\u00e8s',
  clear: 'Effacer',
  apply: 'Appliquer',
  matchAll: 'Correspond \u00e0 tous',
  matchAny: 'Correspond \u00e0 un',
  addRule: 'Ajouter une r\u00e8gle',
  removeRule: 'Supprimer la r\u00e8gle',
  accept: 'Oui',
  reject: 'Non',
  choose: 'Choisir',
  upload: 'T\u00e9l\u00e9charger',
  cancel: 'Annuler',
  dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
  dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
  monthNames: ['Janvier', 'F\u00e9vrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Ao\u00fbt', 'Septembre', 'Octobre', 'Novembre', 'D\u00e9cembre'],
  monthNamesShort: ['Jan', 'F\u00e9v', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Ao\u00fb', 'Sep', 'Oct', 'Nov', 'D\u00e9c'],
  chooseYear: 'Choisir l\'ann\u00e9e',
  chooseMonth: 'Choisir le mois',
  chooseDate: 'Choisir la date',
  prevDecade: 'D\u00e9cennie pr\u00e9c\u00e9dente',
  nextDecade: 'D\u00e9cennie suivante',
  prevYear: 'Ann\u00e9e pr\u00e9c\u00e9dente',
  nextYear: 'Ann\u00e9e suivante',
  prevMonth: 'Mois pr\u00e9c\u00e9dent',
  nextMonth: 'Mois suivant',
  prevHour: 'Heure pr\u00e9c\u00e9dente',
  nextHour: 'Heure suivante',
  prevMinute: 'Minute pr\u00e9c\u00e9dente',
  nextMinute: 'Minute suivante',
  prevSecond: 'Seconde pr\u00e9c\u00e9dente',
  nextSecond: 'Seconde suivante',
  am: 'am',
  pm: 'pm',
  today: 'Aujourd\'hui',
  weekHeader: 'Sem',
  firstDayOfWeek: 1,
  dateFormat: 'dd/mm/yy',
  weak: 'Faible',
  medium: 'Moyen',
  strong: 'Fort',
  passwordPrompt: 'Entrez un mot de passe',
  emptyFilterMessage: 'Aucun r\u00e9sultat trouv\u00e9',
  emptyMessage: 'Aucune option disponible',
  aria: {
    trueLabel: 'Vrai',
    falseLabel: 'Faux',
    nullLabel: 'Non s\u00e9lectionn\u00e9',
    star: '1 \u00e9toile',
    stars: '{star} \u00e9toiles',
    selectAll: 'Tous les \u00e9l\u00e9ments s\u00e9lectionn\u00e9s',
    unselectAll: 'Tous les \u00e9l\u00e9ments d\u00e9s\u00e9lectionn\u00e9s',
    close: 'Fermer',
    previous: 'Pr\u00e9c\u00e9dent',
    next: 'Suivant',
    navigation: 'Navigation',
    scrollTop: 'D\u00e9filer vers le haut',
    moveTop: 'D\u00e9placer en haut',
    moveUp: 'D\u00e9placer vers le haut',
    moveDown: 'D\u00e9placer vers le bas',
    moveBottom: 'D\u00e9placer en bas',
    moveToTarget: 'D\u00e9placer vers la cible',
    moveToSource: 'D\u00e9placer vers la source',
    moveAllToTarget: 'Tout d\u00e9placer vers la cible',
    moveAllToSource: 'Tout d\u00e9placer vers la source',
    pageLabel: 'Page {page}',
    firstPageLabel: 'Premi\u00e8re page',
    lastPageLabel: 'Derni\u00e8re page',
    nextPageLabel: 'Page suivante',
    prevPageLabel: 'Page pr\u00e9c\u00e9dente',
    rowsPerPageLabel: 'Lignes par page',
    jumpToPageDropdownLabel: 'Aller \u00e0 la page',
    jumpToPageInputLabel: 'Aller \u00e0 la page',
    selectRow: 'Ligne s\u00e9lectionn\u00e9e',
    unselectRow: 'Ligne d\u00e9s\u00e9lectionn\u00e9e',
    expandRow: 'Ligne d\u00e9pli\u00e9e',
    collapseRow: 'Ligne repli\u00e9e',
    showFilterMenu: 'Afficher le menu de filtre',
    hideFilterMenu: 'Masquer le menu de filtre',
    filterOperator: 'Op\u00e9rateur de filtre',
    filterConstraint: 'Contrainte de filtre',
    editRow: 'Modifier la ligne',
    saveEdit: 'Enregistrer',
    cancelEdit: 'Annuler',
    listView: 'Vue en liste',
    gridView: 'Vue en grille',
    slide: 'Diapositive',
    slideNumber: '{slideNumber}',
    zoomImage: 'Agrandir l\'image',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arri\u00e8re',
    rotateRight: 'Rotation droite',
    rotateLeft: 'Rotation gauche',
  },
};
